import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

/**
 * Fetches the podcast list in dropdown format.
 * Calls GET /v1/admin/podcasts?mode=dropdown
 * Returns [{label: podcastName, value: _id}] — already react-select ready.
 *
 * Response chain:
 *   axios response.data → { status, data: [{label, value}] }  (gateway wrapper)
 *   hook returns the full axios response, so access options at:
 *   data?.data?.data   (axios.data → gateway body → inner array)
 */
function usePodcastDropdown({ enabled = false, includeUnpublished = false } = {}) {
  const { privateFetch } = useContext(FetchContext);

  return useQuery(
    // Include includeUnpublished in the cache key so exam-info and other callers
    // don't share the same cached result.
    ['podcasts-dropdown', includeUnpublished],
    () =>
      privateFetch.get('/v1/admin/podcasts', {
        params: { mode: 'dropdown', ...(includeUnpublished ? { includeUnpublished: 'true' } : {}) },
      }),
    { enabled, keepPreviousData: true, staleTime: 5 * 60 * 1000 }
  );
}

export default usePodcastDropdown;
